var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotQuietBetween = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 31 31"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.382,
  d: "M23.82 25.99v-2.122a4.39 4.39 0 0 0-3.667-4.328l-2.938-.49V10.57a2.205 2.205 0 0 0-3.766-1.56 2.2 2.2 0 0 0-.647 1.56v11.75l-1.587-.796a2.466 2.466 0 0 0-2.938.499 2.4 2.4 0 0 0 .294 3.474l.614.49"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.382,
  d: "M12.87 10.038H5.457l3.647-3.1a5.55 5.55 0 0 1 6.145-.864 5.55 5.55 0 0 1 6.141.864l3.65 3.1H17.15M20.111 13.137a35 35 0 0 0 4.93-3.096"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.382,
  d: "M5.458 10.037a35 35 0 0 0 4.85 3.035"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  clipPath: "url(#notQuietBetween_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.935 16a14.062 14.062 0 1 0 28.125 0A14.062 14.062 0 0 0 .935 16M5.054 25.944 24.94 6.057"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "notQuietBetween_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 1h30v30H0z"
})))));
export default SvgNotQuietBetween;